import React from 'react'

const RulesRedSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 27.953 27.953'
    >
      <g
        id='Group_1393'
        data-name='Group 1393'
        transform='translate(-379.047 -44)'
      >
        <g
          id='Geri_Butonu'
          data-name='Geri Butonu'
          transform='translate(379.047 44)'
        >
          <path
            id='Path_3258'
            data-name='Path 3258'
            d='M11.556,0A11.556,11.556,0,1,1,0,11.556,11.556,11.556,0,0,1,11.556,0Z'
            transform='translate(2.421 2.421)'
            fill='#c94d4d'
          />
          <g id='Path_3259' data-name='Path 3259' fill='none'>
            <path
              d='M13.977,0A13.977,13.977,0,1,1,0,13.977,13.977,13.977,0,0,1,13.977,0Z'
              stroke='none'
            />
            <path
              d='M 13.9765625 1.000001907348633 C 10.51040267944336 1.000001907348633 7.251703262329102 2.349802017211914 4.800752639770508 4.800752639770508 C 2.349802017211914 7.251703262329102 1.000001907348633 10.51040267944336 1.000001907348633 13.9765625 C 1.000001907348633 17.44272232055664 2.349802017211914 20.70142364501953 4.800752639770508 23.15237236022949 C 7.251703262329102 25.60332298278809 10.51040267944336 26.95312309265137 13.9765625 26.95312309265137 C 17.44272232055664 26.95312309265137 20.70142364501953 25.60332298278809 23.15237236022949 23.15237236022949 C 25.60332298278809 20.70142364501953 26.95312309265137 17.44272232055664 26.95312309265137 13.9765625 C 26.95312309265137 10.51040267944336 25.60332298278809 7.251703262329102 23.15237236022949 4.800752639770508 C 20.70142364501953 2.349802017211914 17.44272232055664 1.000001907348633 13.9765625 1.000001907348633 M 13.9765625 1.9073486328125e-06 C 21.69560241699219 1.9073486328125e-06 27.95312309265137 6.257522583007812 27.95312309265137 13.9765625 C 27.95312309265137 21.69560241699219 21.69560241699219 27.95312309265137 13.9765625 27.95312309265137 C 6.257522583007812 27.95312309265137 1.9073486328125e-06 21.69560241699219 1.9073486328125e-06 13.9765625 C 1.9073486328125e-06 6.257522583007812 6.257522583007812 1.9073486328125e-06 13.9765625 1.9073486328125e-06 Z'
              stroke='none'
              fill='#c94d4d'
            />
          </g>
        </g>
        <text
          id='_'
          data-name='?'
          transform='translate(390 63)'
          fill='#fff'
          fontSize='15'
          fontFamily='Roboto-Regular, Roboto'
        >
          <tspan x='0' y='0'>
            ?
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default RulesRedSvg
